import { render, staticRenderFns } from "./RequestsList.vue?vue&type=template&id=e9b9f8a0&"
import script from "./RequestsList.vue?vue&type=script&lang=js&"
export * from "./RequestsList.vue?vue&type=script&lang=js&"
import style0 from "./RequestsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports